const API = {
  loginByPhoneCode: 'api/user/loginByPhoneCode',    //手机验证码登录   https://showdoc.mamcharge.com/web/#/626?page_id=10620
  sendPhoneCode: 'api/user/sendPhoneCode',    //发送短信验证码   https://showdoc.mamcharge.com/web/#/626?page_id=10621
  getGlobalData: 'api/property/getData',    //获取全局数据(看板)   https://showdoc.mamcharge.com/web/#/626?page_id=10668
  getUserProfitOverview: 'api/property/getUserProfitOverview',    //用户收益概览
  getUserPropertyOverview: 'api/property/getUserPropertyOverview',    //用户资产概览
  getPlatformProfitOverview: 'api/property/getPlatformProfitOverview',    //平台经营数据概览
  getUserPropertyProfit: 'api/property/getUserPropertyProfit',    //用户资产收益和提现信息
  gePropertyList: 'api/property/gePropertyList',    //获取用户资产列表
  getPropertyDetail: 'api/property/getPropertyDetail',    //获取资产详情
  get7DayProfit: 'api/property/get7DayProfit',    //获取用户近7天收益
  getConfigInfo: 'api/property/getConfigInfo',    //获取资产配置信息
  orderSubmit: 'api/order/submit',    //下单（认购资产）
  getOrderList: 'api/order/getOrderList',    //订单列表
  withdraw: 'api/order/withdraw',    //申请提现
  getWithdrawList: 'api/order/getWithdrawList',    //提现记录
}

export default API;